import { accountTrainCourseEntityName } from '@juvare/credentialing/backend/features/train-courses';
export function getTrainAccountFilter(trainCourseIds) {
    const accountTrainCourseFilter = [];
    if (!trainCourseIds.length) {
        return [];
    }
    accountTrainCourseFilter.push({
        column: 'courseId',
        op: 'in',
        value: trainCourseIds,
    });
    return [
        {
            op: 'in',
            idSubFilter: {
                entity: accountTrainCourseEntityName,
                column: 'accountId',
                filter: accountTrainCourseFilter,
            },
        },
    ];
}
